export enum ChartTypes {
  AMOUNT = 'amount',
  COUNT = 'count',
}
